import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { usePopper } from "react-popper";
import { useRef, useState } from "react";
import { bottom, top, left, right } from "@popperjs/core";
import Image from "../../components/elements/Image";
import { classNames } from "../../helpers/classNames";
import { Tooltip } from "react-tooltip";
import LogoutModal from "../../components/LogoutModal/LogoutModal";

const UserDropdown = ({
  role,
  data,
  isFront,
  xPlacement,
  dropdownContainer,
  ...props
}) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [passwordModal, setPasswordModal] = useState({
    isOpen: false,
  });
  const [profileModal, setProfileModal] = useState({
    isOpen: false,
  });
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);

  const placements = {
    bottom: bottom,
    bottomLeft: "bottom-start",
    bottomRight: "bottom-end",
    top: top,
    topLeft: "top-start",
    topRight: "top-end",
    right: right,
    left: left,
    "": bottom,
  };
  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const dropdownData =
    isFront === true
      ? [
          {
            _id: 1,
            name: "Profile",
            icon: "fa-regular fa-circle-user",
            onclick: (val) => {
              setProfileModal({ isOpen: true });
            },
            standout: false,
          },
          {
            _id: 2,
            name: "Change Password",
            icon: "fa-regular fa-gear",
            onclick: (val) => {
              setPasswordModal({ isOpen: true });
            },
            standout: false,
          },
          {
            _id: 3,
            name: "Logout",
            icon: "fa-regular fa-arrow-right-from-arc",
            onclick: (val) => {
              setIsLogOutModelOpen(true);
            },
            standout: true,
          },
        ]
      : [
          {
            _id: 1,
            name: "Profile",
            icon: "fa-regular fa-circle-user",
            link: "/user/profile",
            standout: false,
          },
          {
            _id: 2,
            name: "Settings",
            icon: "fa-regular fa-gear",
            link: "/admin/site-settings",
            standout: false,
          },
          {
            _id: 3,
            name: "Logout",
            icon: "fa-regular fa-arrow-right-from-arc",
            onclick: (val) => {
              setIsLogOutModelOpen(true);
            },
            standout: true,
          },
        ];

  return (
    <>
      <Menu as="div">
        {({ open }) => (
          <>
            <MenuButton
              ref={setTargetElement}
              className={classNames(
                "flex items-center justify-center w-8 aspect-square transition-all duration-200 hover:bg-shades-04 text-blue-zodiac rounded text-sm",
                open ? "bg-shades-04" : "bg-transparent"
              )}
            >
              <i className="fa-regular fa-fw fa-ellipsis-vertical transition-all duration-200"></i>
            </MenuButton>
            <Transition
              as={Fragment}
              className="z-50"
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
              beforeEnter={() => setPopperElement(popperElRef.current)}
              afterLeave={() => setPopperElement(null)}
              ref={popperElRef}
              style={styles.popper}
              {...attributes.popper}
            >
              <MenuItems
                className={classNames(
                  "absolute border border-slate-200 w-40 origin-top-right rounded-md bg-white shadow-lg focus:outline-none py-1",
                  dropdownContainer
                )}
              >
                <div className="py-1 max-h-80 overflow-auto scroll-smooth scrollbar">
                  {dropdownData.map((item) => (
                    <MenuItem key={item._id}>
                      {({ active }) =>
                        item?.link ? (
                          <Link
                            to={item?.link}
                            className={classNames(
                              "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active
                                ? "bg-red-100 text-chestnut-rose"
                                : "text-slate-500",
                              item.standout
                                ? "!text-opplio-red hover:!bg-opplio-red/10"
                                : "",
                              item.class
                            )}
                          >
                            {item.icon && (
                              <i className={classNames("fa-fw", item.icon)}></i>
                            )}
                            <span>{item.name}</span>
                          </Link>
                        ) : (
                          <div
                            onClick={item?.onclick}
                            className={classNames(
                              "group cursor-pointer flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active
                                ? "bg-red-100 text-chestnut-rose"
                                : "text-slate-500",
                              item.standout
                                ? "!text-red-500 hover:!bg-red-500/10"
                                : "",
                              item.class
                            )}
                          >
                            {item.icon && (
                              <i className={classNames("fa-fw", item.icon)}></i>
                            )}
                            <span>{item.name}</span>
                          </div>
                        )
                      }
                    </MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Transition>
          </>
        )}
      </Menu>
      <LogoutModal
        setIsOpen={(val) => setIsLogOutModelOpen(val)}
        isOpen={isLogoutModelOpen}
      />
    </>
  );
};

export default UserDropdown;
